<template>
  <div class="flex items-center text-xs">
    <div
      class="h-3 w-3 rounded-xs border-0"
      :style="{
        backgroundColor:
          SCORECARD_COLOR_SWATCHES[
            model.index % SCORECARD_COLOR_SWATCHES.length
          ],
      }"
    />
    <p class="pl-3">{{ model.name }}</p>
  </div>
</template>

<script setup lang="ts">
import { SCORECARD_COLOR_SWATCHES } from "@/helpers/constants";

import type { ScorecardForGroupTable } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  model: {
    type: Object as PropType<ScorecardForGroupTable>,
    required: true,
  },
});
</script>
